export default "__VITE_ASSET__e8651bf4__"